import { DigitalDossierGeneralInformationSerializer } from '@bcba/serializers';
import { FormSection } from '../../DigitalDossier/DigitalDossierSection/components/FormSection';
import { useTranslation } from '@bcba/react-hooks';
import { Grid, ReadOnlyField } from '@agrotoken-tech/ui';
import {
  formatDateToShortFormat,
  unixTimestampToDate,
} from '@bcba/common-utils';

type Props = {
  data: DigitalDossierGeneralInformationSerializer;
};

export const ReadOnlyGeneralInfoSection = ({ data }: Props) => {
  const { t } = useTranslation();
  const {
    companyFiscalId,
    name,
    companyType,
    mainActivities,
    activityStartDate,
    activityEndDate,
    rucaStatus,
    igjIdentifier,
    sisaActivities,
    sisaScoring,
  } = data;
  return (
    <FormSection title={t('common.companyGeneralInformation')}>
      <Grid templateColumns={{ md: 'repeat(2, 1fr)' }} gap={6}>
        <ReadOnlyField label={t('common.CUIT')} value={companyFiscalId} />
        <ReadOnlyField label={t('common.companyName')} value={name} />
        <ReadOnlyField
          label={t('common.companyType')}
          value={companyType ? t(`companyTypes.${companyType}`) : '-'}
        />
        <ReadOnlyField
          value={
            mainActivities
              ?.map((a) => t(`companyActivities.${a}`))
              .join(', ') ?? '-'
          }
          label={t('common.activity')}
        />
        <ReadOnlyField
          value={
            activityStartDate
              ? formatDateToShortFormat(unixTimestampToDate(activityStartDate))
              : '-'
          }
          label={t('common.startDateOfActivity')}
        />
        <ReadOnlyField
          value={
            activityEndDate
              ? formatDateToShortFormat(unixTimestampToDate(activityEndDate))
              : '-'
          }
          label={t('common.endDateOfActivity')}
        />
        <ReadOnlyField
          value={rucaStatus ? t(`rucaStatus.${rucaStatus}`) : '-'}
          label={t('common.RUCA')}
        />
        <ReadOnlyField value={igjIdentifier ?? '-'} label={t('common.IGJ')} />
        <ReadOnlyField
          value={
            sisaActivities?.map((a) => t(`sisaActivities.${a}`)).join(', ') ??
            '-'
          }
          label={t('common.sisaActivity')}
        />
        <ReadOnlyField
          value={sisaScoring ? t(`sisaScoring.${sisaScoring}`) : '-'}
          label={t('common.sisaScoring')}
        />
      </Grid>
    </FormSection>
  );
};
